module.exports = __webpack_public_path__ + "img/06995647000187.183faec2.png";